import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Breadcrumb from '../../../ui/atoms/Breadcrumb';
import { Container } from '../../../ui/gridSystem';
import { Tabs, Text } from '../../../ui/atoms';
import routes from '../../../routes';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import NewRequests from './NewRequests';
import OldRequests from './OldRequests';

const defaultTabs = [
  { value: 'new', label: 'Richieste da approvare' },
  { value: 'old', label: 'Storico richieste' },
];

const ApprovalList = ({ newPager, oldPager }) => {
  const navigate = useNavigate();
  const [tabs, setTabs] = useState(defaultTabs);
  const [activeTab, setActiveTab] = useState(defaultTabs[0]);

  useEffect(() => {
    const newTabs = [...defaultTabs];
    newTabs[0].items = newPager?.total_items ?? 0;
    newTabs[1].items = oldPager?.total_items ?? 0;
    setTabs(newTabs);
  }, [newPager?.total_items, oldPager?.total_items]);

  return (
    <>
      <Breadcrumb
        crumbs={[
          {
            label: 'Gestione percorsi formativi',
            onClick: () => navigate(routes.tutorCourseList.path),
          },
          { label: 'Gestione richieste di approvazione' },
        ]}
      />
      <Container className="pt-0">
        <Text type="h1" mb={8}>
          Gestione richieste di approvazione
        </Text>
        <Text type="b3" mb={40}>
          Sezione dedicata alla gestione delle richieste di approvazione.
        </Text>
        <Tabs
          tabs={tabs}
          selected={activeTab}
          onChange={(tab) => {
            setActiveTab(tab);
          }}
        />
        <div style={{ display: activeTab?.value === 'new' ? 'block' : 'none' }}>
          <NewRequests active={activeTab?.value === 'new'} />
        </div>
        <div style={{ display: activeTab?.value === 'old' ? 'block' : 'none' }}>
          <OldRequests active={activeTab?.value === 'old'} />
        </div>
      </Container>
    </>
  );
};

ApprovalList.propTypes = {
  newPager: PropTypes.object,
  oldPager: PropTypes.object,
};

export default connect(
  (state) => {
    const {
      newRequests: { pager: newPager },
      oldRequests: { pager: oldPager },
    } = state.eventApproval;
    return { newPager, oldPager };
  },
  (dispatch) => ({})
)(withMediaQueries(ApprovalList));
